// import axios from "axios";

// const OTdetailsService = axios.create({
//   //baseURL: "http://172.30.30.96:9000/api/attendance/",//baseURL: "https://esystems.cdl.lk/QRApp_BackEnd/api/attendance/",
//   //baseURL: "http://172.30.30.96:2500/",
//   baseURL: "https://esystems.cdl.lk/backend/AttendMe2/",
//   headers: {
//     UserId: "DTSUSER",
//     Password: "Dts@10099",
//   },
// });



// export default OTdetailsService;


 import axios from "axios";

const OTdetailsService = {
  getAssignOT: (date, serviceNo ) =>
    axios.get(
      `attme/GetAssignOTDetails?date=${date}&serviceNo=${serviceNo}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),
};

export default OTdetailsService;


